<template lang="html">
  <v-layout row wrap v-if="status_login === 'T'" style="overflow: hidden !important;">
    <v-flex xs12 class="setBgHeader widthfull" :style="{background: backgroudHeader}">
      <h3 class="centerDiv mt-1" style="color: white">แชทกับเรา</h3>
    </v-flex>
    <v-flex xs12 style="background: white !important;">
      <v-layout row wrap>
    <v-flex xs12 class="headername widthfull">
      <v-avatar class="f-l mr-2 user-photoprofilechat" >
        <img src="/static/img/call-center.png" alt="John" class="alligator-turtle">
      </v-avatar>
      <v-layout row wrap align-center style="padding-top: 12px;">
        <h4 style="margin-left: 1vw;">หัวข้อปัญหา : {{subject}}</h4>
      </v-layout>
    </v-flex>
    <v-flex xs12 class="setHeightChatBox" id="myscroll" v-on:scroll="scrollFunction">
      <!-- The Modal Pic-->
      <div id="myModal" class="modalc">
        <div id="headcaption">
          <v-container >
            <v-layout row wrap align-center justify-end>
              <v-flex xs12 md12 sm12 xl12 lg12>
                <span class="close" @click="closemodal()">&times;</span>
              </v-flex>
            </v-layout>
          </v-container>
        </div>
          <img class="modal-contentc" id="img01">
      </div>
      <!-- The Modal File -->
      <div class="modalc" id="myModalFile" >
        <div id="headcaption">
          <v-container>
            <v-layout row wrap align-center justify-end>
              <v-flex xs12 md12 sm12 xl12 lg12>
                <span class="close" @click="closemodal()">&times;</span>
              </v-flex>
            </v-layout>
          </v-container>
        </div>
          <iframe :src="filepdf" style="width:100%; height:100%;justify-content: center;" frameborder="0"></iframe>
      </div>
      <v-layout row wrap v-for="(item,index) in listmessage" :key="item.id">
        <!-- deate time && btn load msg-->
        <v-layout row wrap align-center justify-center style="margin-bottom: 15px;">
          <div v-if="index == 0">
            <div class="text-xs-center" @click="loadchathistory" v-if="statusload">
              <v-btn small round outline color="primary" style="background: #ff000000 !important;text-transform: none; font-size: 12px;"><v-icon left style="font-size: 16px !important;" @click="loadchathistory">refresh</v-icon>โหลดข้อความก่อนหน้า</v-btn>
            </div>
            <div class="conversation-start" style="text-align:center;" v-if="tokenroom === item.room">
              <span>{{momentdate(item.date)}}</span>
             </div>
          </div>
          <div v-else-if="item.date !== listmessage[index-1].date">
            <br>
            <v-flex xl12 md12 sm12 lg12>
            <div class="conversation-start" style="text-align:center;" v-if="tokenroom === item.room">
              <span>{{momentdate(item.date)}}</span>
            </div>
           </v-flex>
          </div>
        </v-layout>
        <!-- admin -->
        <v-flex xs12 ml-3 mb-2 v-if="item.type == 'admin'" >
          <v-avatar class="f-l mr-2" >
            <img src="/static/img/call-center.png" alt="John">
          </v-avatar>
          <v-tooltip right>
            <!-- type message -->
            <div class="chatBoxFriend f-l" slot="activator" v-if="item.typemessage === 'message'" v-html="convert(item.msg).replace(/(?:\r\n|\r|\n)/g, '<br>')">
            </div>
            <!-- type image -->
            <div class="chatBoxFriend f-l" slot="activator" v-else-if="item.typemessage === 'image'">
              <img :src="item.msg" class="imageChat" @click="zoom(item.msg,item.filename,item.chatname,item.profilepicture,item.date,item.timestamp,item.tokenmessage,item.type)" style="cursor: pointer;">
            </div>
            <!-- type file -->
            <div class="chatBoxFriend f-l" slot="activator" v-else-if="item.typemessage === 'file'">
              <div v-if="extension(item.filename) === 'pdf'" @click="zoomfile(item.msg,item.filename,item.chatname,item.profilepicture,item.date,item.timestamp,item.tokenmessage,item.type)" style="cursor: pointer;">
                <pdf
                  :src="item.msg"
                  :page="1"
                  ref="myPdfComponent"
                ></pdf>
                <p class="textfile">{{item.filename}}</p>
              </div>
              <div v-else-if="extension(item.filename) === 'mp4'">
                <video width="150" height="170" controls>
                  <source :src="item.msg" type="video/mp4">
                </video>
              </div>
              <div v-else-if="extension(item.filename) === 'wmv'">
                <video width="150" height="170" controls>
                  <source :src="item.msg" type="video/wmv">
                </video>
              </div>
              <div v-else-if="extension(item.filename) === 'ogg'">
                <video width="150" height="170" controls>
                  <source :src="item.msg" type="video/ogg">
                </video>
              </div>
              <div v-else-if="extension(item.filename) === 'acc'">
                <audio style="width: 150px !important; height: 60px !important;" controls>
                  <source :src="item.msg" type="audio/acc">
                </audio>
              </div>
              <div v-else-if="extension(item.filename) === 'wav'">
                <audio style="width: 150px !important; height: 60px !important;" controls>
                  <source :src="item.msg" type="audio/wav">
                </audio>
              </div>
              <div v-else>
                <v-icon class="iconfile">{{extension(item.filename)}}</v-icon>
                <p class="textfile">{{item.filename}}</p>
              </div>
            </div>
            <!-- type other -->
            <div class="chatBoxFriend f-l" slot="activator" v-else>
              ข้อความนี้ไม่รองรับในเวอร์ชันนี้
            </div>
            <span>{{momenttime(item.timestamp)}}</span>
          </v-tooltip>
        </v-flex>
        <!-- guest -->
        <v-flex xs12 mr-3 mb-2 v-else-if="item.type == 'guest'" >
          <v-tooltip left >
            <!-- type message -->
            <div class="chatBox f-r" slot="activator" v-if="item.typemessage === 'message'" :style="{background: chatbox}" v-html="convert(item.msg).replace(/(?:\r\n|\r|\n)/g, '<br>')">
            </div>
            <!-- type image -->
            <div class="chatBox f-r" slot="activator" v-else-if="item.typemessage === 'image'" :style="{background: chatbox}">
              <img :src="item.msg" class="imageChat" @click="zoom(item.msg,item.filename,item.chatname,item.profilepicture,item.date,item.timestamp,item.tokenmessage,item.type)" style="cursor: pointer;">
            </div>
            <!-- type file -->
            <div class="chatBox f-r" slot="activator" v-else-if="item.typemessage === 'file'" :style="{background: chatbox}">
              <div v-if="extension(item.filename) === 'pdf'" @click="zoomfile(item.msg,item.filename,item.chatname,item.profilepicture,item.date,item.timestamp,item.tokenmessage,item.type)" style="cursor: pointer;">
                <pdf
                  :src="item.msg"
                  :page="1"
                  ref="myPdfComponent"
                ></pdf>
                <p class="textfile">{{item.filename}}</p>
              </div>
              <div v-else-if="extension(item.filename) === 'mp4'">
                <video width="150" height="170" controls>
                  <source :src="item.msg" type="video/mp4">
                </video>
              </div>
              <div v-else-if="extension(item.filename) === 'wmv'">
                <video width="150" height="170" controls>
                  <source :src="item.msg" type="video/wmv">
                </video>
              </div>
              <div v-else-if="extension(item.filename) === 'ogg'">
                <video width="150" height="170" controls>
                  <source :src="item.msg" type="video/ogg">
                </video>
              </div>
              <div v-else-if="extension(item.filename) === 'acc'">
                <audio style="width: 150px !important; height: 60px !important;" controls>
                  <source :src="item.msg" type="audio/acc">
                </audio>
              </div>
              <div v-else-if="extension(item.filename) === 'wav'">
                <audio style="width: 150px !important; height: 60px !important;" controls>
                  <source :src="item.msg" type="audio/wav">
                </audio>
              </div>
              <div v-else>
                <v-icon class="iconfile">{{extension(item.filename)}}</v-icon>
                <p class="textfile">{{item.filename}}</p>
              </div>
            </div>
            <!-- type other -->
            <div class="chatBox f-r" slot="activator" v-else :style="{background: chatbox}">
              ข้อความนี้ไม่รองรับในเวอร์ชันนี้
            </div>
            <span>{{momenttime(item.timestamp)}}</span>
          </v-tooltip>
        </v-flex>
      </v-layout>
    </v-flex>

    <v-flex xs12>
      <div class="textBox" v-if="status_room !== 'close'">
        <v-layout row wrap>
          <v-flex xs12 pl-2 pt-1>
            <textarea class="widthfull" rows="2" cols="50" placeholder="พิมพ์ข้อความของคุณที่นี่" v-model="msg" @keyup.enter="sendMessage(msg)">
            </textarea>
          </v-flex>
        </v-layout>
      </div>
      <div class="texboxdisabled" v-else>
        <v-layout row wrap>
          <v-flex xs12 pl-2 pt-1>
            <textarea class="widthfull" rows="2" cols="50" placeholder="ไม่สามารถพิมพ์ข้อความได้" v-model="msg" @keyup.enter="sendMessage(msg)" disabled>
            </textarea>
          </v-flex>
        </v-layout>
      </div>
    </v-flex>
    <v-layout align-center justify-center row wrap>
      <v-flex xs8 pl-2>
        <v-layout align-center justify-start row wrap>
          <Menusetting @pushfile="pushfile" @sound="sound"/>
          <span class="colorFooterMenu">สวัสดีคุณ :</span>
          <span class="textname">{{name}}</span>
        </v-layout>
      </v-flex>
      <v-flex xs4 pr-2>
        <v-layout align-center justify-end row wrap>
          <a href="https://chat.one.th/" target="_blank" style="font-size: 10px;">Power by One Chat</a>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-layout>
</v-flex>
</v-layout>
</template>

<script>
import Menusetting from '@/components/Menusetting'
import { Momenttime } from '@/services'
import pdf from 'vue-pdf'
// import VueGallerySlideshow from 'vue-gallery-slideshow'
import { sync } from 'vuex-pathify'
var _ = require('lodash')
const theme = require('../assets/theme')

export default {
  data () {
    return {
      soundOpen: true,
      filepdf: '',
      theme,
      status_room: '',
      con_code: '',
      chatboximage: '',
      chatboxfile: '',
      statusload: false,
      chatbox: '',
      backgroudHeader: '',
      servicename: '',
      listmessage: [],
      msg: '',
      email: '',
      tokenservice: '',
      body: '',
      headers: '',
      tokenuser: '',
      tokenroom: '',
      date: '',
      time: '',
      name: '',
      adminname: '',
      subject: '',
      status_login: '',
      scrollMaxOld: 0,
      keyservice: '',
      nicknameSend: '',
      filenameSend: '',
      picSend: '',
      dateSend: '',
      timeSend: '',
      tokenmsgSend: '',
      pathSend: '',
      typeuserSend: '',
      focus: true
    }
  },
  created () {
    this.$socket.emit('connect')
    this.tokenroom = this.$route.params.tokenroom
    this.con_code = this.$route.params.concode
    var servicename = this.$route.params.servicename
    if (this.theme[servicename].servicename === this.$route.params.servicename) {
      this.tokenservice = 'Bearer ' + this.theme[servicename].authen
      this.backgroudHeader = this.theme[servicename].background
      this.chatbox = this.theme[servicename].chatbox
    } else {
      this.tokenservice = 'Bearer ' + this.theme[servicename].authen
      this.backgroudHeader = '#01579b'
      this.chatbox = '#B3E5FC'
    }
    this.headers = {headers: {'Authorization': this.tokenservice}}
    this.body = {tokenroom: this.tokenroom, con_code: this.con_code}
    this.axios.post(process.env.APImanage + '/get_room_by_concode_tokenroom', this.body, this.headers).then((response) => {
      // console.log(response.data)
      if (response.data.status === 'success') {
        // console.log(response.data)
        this.tokenuser = response.data.data.tokenuser
        this.name = response.data.data.nickname
        this.subject = response.data.data.subject
        this.status_login = 'T'
        this.servicename = response.data.data.service_name
        this.status_room = response.data.data.status.status
        // localStorage.setItem('tokenuser', this.tokenuser)
        // localStorage.setItem('tokenroom', this.tokenroom)
        // localStorage.setItem('subject', this.subject)
        // localStorage.setItem('name', this.name)
        // localStorage.setItem('servicename', this.servicename)
        // localStorage.setItem('status_login', this.status_login)
        // localStorage.setItem('status_room', this.status_room)
        this.myname = this.name
        this.mysubject = this.subject
        this.mytokenroom = this.tokenroom
        this.mytokenuser = this.tokenuser
        this.myservicename = this.servicename
        this.mystatuslogin = this.status_login
        this.mystatusroom = this.status_room
        this.listmessage = []
        // console.log(this.mytokenuser)
        // console.log(this.tokenuser)
        this.$socket.emit('connect')
        this.getMessageFirst()
      } else {
        this.status_login = 'F'
        this.mystatuslogin = this.status_login
        // localStorage.setItem('status_login', this.status_login)
      }
    })
  },
  components: {
    Menusetting,
    pdf
    // VueGallerySlideshow
  },
  computed: {
    ...sync('*')
  },
  watch: {
    msg () {
      if (event.keyCode === 13 && event.shiftKey) {
        if (event.type === 'keypress') {
          this.pasteIntoInput(this, '\n')
        }
        event.preventDefault()
      } else if (event.keyCode === 13) {
        if (event.type === 'keypress') {
          this.pasteIntoInput(this, '')
        }
        event.preventDefault()
      }
    },
    '$route.params.tokenroom' () {
      this.scrollMaxOldSet()
      this.statusload = false
      var container = this.$el.querySelector('#myscroll')
      container.scrollTop = container.scrollHeight
      this.tokenroom = this.$route.params.tokenroom
      this.listmessage = []
      this.getMessageFirst()
    },
    socketmessage () {
      this.getMessageSocket(this.socketmessage)
    }
  },
  sockets: {
    connect () {
      console.log('socket connected')
      // console.log(this.mytokenuser)
      // console.log(this.tokenuser)
      this.$socket.emit('join_room', {room: this.mytokenuser, type: 'web'})
    },
    disconnect: function () {
      console.log('disconnect')
    },
    message (data) {
      console.log('message')
      // console.log(data)
      if (data.hasOwnProperty('tokenuser')) {
        this.headers = {headers: {'Authorization': this.tokenservice}}
        this.body = {tokenmessage: data.tokenmessage, tokenuser: this.tokenuser}
        this.axios.post(process.env.APImanage + '/getmessage', this.body, this.headers).then((response) => {
          this.socketmessage = response.data.source
          // console.log(this.socketmessage)
          if (data.tokenuser !== this.tokenuser) {
            this.beep()
            if (document.hidden) {
              if (response.data.source.typeofmessage !== 'message') {
                this.noti_msg(data.service_name, 'Send:  ' + response.data.source.typeofmessage + ' to you', response.data.source.tokenroom, response.data.source.path_pic, response.data.source.type)
                // alert('Admin')
              } else {
                this.noti_msg(data.service_name, 'Message:  ' + response.data.source.message, response.data.source.tokenroom, response.data.source.path_pic, response.data.source.type)
              }
            }
          }
        })
      }
    },
    close_ticket (data) {
      console.log('close_ticket')
      // console.log(data)
      // localStorage.setItem('status_room', 'close')
      this.mystatusroom = 'close'
      this.$router.push('/rating/' + this.servicename + '/' + this.con_code + '/' + this.tokenroom)
    }
  },
  methods: {
    beep () {
      if (this.soundOpen) {
        var snd = new Audio(require('./../assets/comedy.wav'))
        snd.play()
      }
    },
    sound (data) {
      this.soundOpen = data
    },
    onblurtest () {
      this.focus = false
      console.log(this.focus)
    },
    onfocustest () {
      this.focus = true
      console.log(this.focus)
    },
    closemodal () {
      var modal = document.getElementById('myModal')
      var modalfile = document.getElementById('myModalFile')
      modal.style.display = 'none'
      modalfile.style.display = 'none'
    },
    zoom (url, alt, nickname, pic, date, time, tokenmessage, type) {
      var modal = document.getElementById('myModal')
      var modalImg = document.getElementById('img01')
      modal.style.display = 'block'
      modalImg.src = url
      this.nicknameSend = nickname
      this.filenameSend = alt
      this.picSend = pic
      this.dateSend = date
      this.timeSend = time
      this.tokenmsgSend = tokenmessage
      this.pathSend = url
      this.typeuserSend = type
    },
    zoomfile (url, alt, nickname, pic, date, time, tokenmessage, type) {
      var modalfile = document.getElementById('myModalFile')
      modalfile.style.display = 'block'
      this.filepdf = url
      this.nicknameSend = nickname
      this.filenameSend = alt
      this.picSend = pic
      this.dateSend = date
      this.timeSend = time
      this.tokenmsgSend = tokenmessage
      this.typeuserSend = type
    },
    noti_msg (title, notimsg, room) {
      // if (pic === '') {
      var pic = '/static/img/call-center.png'
      // }
      if (Notification.permission === 'granted') {
        var notification = new Notification(title, { body: notimsg, icon: pic })
        // console.log(notification.silent)
        notification.onclick = function () {
          // window.open(room, '_parent').focus()
        }
      } else {
        Notification.requestPermission().then(function (result) {
          console.log(result)
        })
      }
    },
    pushfile (file, filename) {
      var uploadFile = new FormData()
      uploadFile.append('file', file, filename)
      uploadFile.append('to', this.tokenroom)
      uploadFile.append('user_id', this.mytokenuser)
      uploadFile.append('type', 'file')
      this.headers = {headers: {'Authorization': this.tokenservice}}
      this.axios.post(process.env.APImanage + '/push_message', uploadFile, this.headers).then((response) => {
        // console.log(response.data)
        this.momentdate(response.data.timestamp)
        this.time = this.momenttime(response.data.timestamp)
        if (_.find(this.listmessage, function (o) { return o.tokenmessage === response.data.tokenmessage }) === undefined) {
          this.listmessage.push({
            sender: 'self',
            msg: response.data.message,
            room: response.data.tokenroom,
            tokenuser: response.data.tokenuser,
            typemessage: response.data.typeofmessage,
            timestamp: response.data.timestamp,
            tokenmessage: response.data.tokenmessage,
            profilepicture: this.profile,
            chatname: response.data.nickname,
            filename: response.data.file_name,
            status: 'success',
            type: 'guest'
          })
          this.listmessage = _.sortBy(this.listmessage, function (dateObj) {
            return new Date(dateObj.timestamp)
          })
          this.listmessage = _.unionBy(this.listmessage, 'tokenmessage')
        }
        setTimeout(this.scrollDown, 1)
      })
    },
    sendMessage (data) {
      try {
        if (event.keyCode === 13 && event.shiftKey) {
          if (event.type === 'keypress') {
            this.pasteIntoInput(this, '\n')
          }
          event.preventDefault()
        } else if (!this.isBlank(data) && !this.isEmpty(data)) {
          this.msg = ''
          this.body = {user_id: this.tokenuser, to: this.tokenroom, type: 'text', message: data}
          this.headers = {headers: {'Authorization': this.tokenservice}}
          this.axios.post(process.env.APImanage + '/push_message', this.body, this.headers).then((response) => {
            // if (response.data.status === 'success') {
            // console.log(response.data)
            this.date = this.momentdate(response.data.timestamp)
            this.time = this.momenttime(response.data.timestamp)
            if (_.find(this.listmessage, function (o) { return o.tokenmessage === response.data.tokenmessage }) === undefined) {
              this.listmessage.push({
                sender: 'self',
                msg: response.data.message,
                room: response.data.tokenroom,
                tokenuser: response.data.tokenuser,
                typemessage: response.data.typeofmessage,
                timestamp: response.data.timestamp,
                tokenmessage: response.data.tokenmessage,
                profilepicture: response.data.path_pic,
                chatname: response.data.nickname,
                filename: response.data.file_name,
                status: 'success',
                type: 'guest'
              })
              this.listmessage = _.sortBy(this.listmessage, function (dateObj) {
                return new Date(dateObj.timestamp)
              })
              this.listmessage = _.unionBy(this.listmessage, 'tokenmessage')
            }
            setTimeout(this.scrollDown, 1)
            this.msg = ''
            // } else {
            //   var moment = require('moment')
            //   this.date = moment().tz('Pacific/Kiritimati').lang('th').format('ll')
            //   this.time = moment().tz('Pacific/Kiritimati').lang('th').format('LT')
            //   this.listmessage.push({
            //     sender: 'self',
            //     msg: this.msg,
            //     room: this.$route.params.id,
            //     tokenuser: this.tokenuser,
            //     date: this.date,
            //     timeofdate: this.time,
            //     typemessage: 'message',
            //     tokenmessage: '',
            //     filename: '',
            //     chatname: '',
            //     profilepicture: '',
            //     type: 'guest'})
            //   this.msg = ''
            // }
          })
        }
      } catch (e) {
        if (!this.isBlank(data) && !this.isEmpty(data)) {
          this.msg = ''
          this.body = {user_id: this.tokenuser, to: this.tokenroom, type: 'text', message: data}
          this.headers = {headers: {'Authorization': this.tokenservice}}
          this.axios.post(process.env.APImanage + '/push_message', this.body, this.headers).then((response) => {
            this.msg = ''
          })
        }
      }
    },
    scrollFunction () {
      // var scroll = this.$el.querySelector('#myscroll')
      // console.log(scroll.scrollTop)
      // if (scroll.scrollTop >= ((scroll.scrollHeight - this.box_height))) {
      // เห็นข้อความแล้ว ไม่ต้องทำอะไร
      // setTimeout(this.scrollDown, 1)
      // this.showmessagebottom = false
    },
    scrollMaxOldSet () {
      // var container = this.$el.querySelector('#myscroll')
      this.scrollMaxOld = 0
    },
    scrollDown () {
      var container = this.$el.querySelector('#myscroll')
      container.scrollTop = container.scrollHeight
      this.scrollval = container.scrollTop
    },
    loadchathistory () {
      this.progressLoadChat = true
      var container = this.$el.querySelector('#myscroll')
      this.scrollval = container.scrollTop
      if (this.scrollval < 20) {
        this.getOldMessage()
        var scrollMaxNew = container.scrollHeight
        container.scrollTop = scrollMaxNew - this.scrollMaxOld
        this.scrollMaxOld = scrollMaxNew
        this.scrollval = container.scrollTop
      }
    },
    getMessageSocket (data) {
      this.date = this.momentdate(data.timestamp)
      this.time = this.momenttime(data.timestamp)
      // console.log(this.listmessage)
      // console.log(data)
      // console.log(this.listmessage[0]['tokenmessage'] === data.tokenmessage)
      // console.log(_.find(this.listmessage, function (o) { return o.tokenmessage === data.tokenmessage }) === undefined)
      // console.log(data.tokenmessage)
      if (data.tokenuser === this.mytokenuser) {
        if (_.find(this.listmessage, function (o) { return o.tokenmessage === data.tokenmessage }) === undefined && this.listmessage.length !== 0) {
          if (data.tokenroom === this.tokenroom) {
            this.listmessage.push({
              sender: 'self',
              msg: data.message,
              room: data.tokenroom,
              tokenuser: data.tokenuser,
              typemessage: data.typeofmessage,
              timestamp: data.timestamp,
              tokenmessage: data.tokenmessage,
              profilepicture: data.path_pic,
              chatname: data.nickname,
              filename: data.file_name,
              type: 'guest'})
            this.listmessage = _.sortBy(this.listmessage, function (dateObj) {
              return new Date(dateObj.timestamp)
            })
            this.listmessage = _.unionBy(this.listmessage, 'tokenmessage')
            // console.log(this.listmessage)
            setTimeout(this.scrollDown, 1)
          }
        }
      } else {
        this.listmessage.push({
          sender: 'other',
          msg: data.message,
          room: data.tokenroom,
          tokenuser: data.tokenuser,
          typemessage: data.typeofmessage,
          timestamp: data.timestamp,
          tokenmessage: data.tokenmessage,
          profilepicture: data.path_pic,
          chatname: data.nickname,
          filename: data.file_name,
          type: 'admin'})
        this.listmessage = _.sortBy(this.listmessage, function (dateObj) {
          return new Date(dateObj.timestamp)
        })
        this.listmessage = _.unionBy(this.listmessage, 'tokenmessage')
        setTimeout(this.scrollDown, 1)
        // console.log(this.listmessage)
      }
    },
    getOldMessage () {
      if (this.listmessage.length === 0) {
      } else {
        var lastitem = this.listmessage[0]
        // console.log(this.listmessage[0])
        this.body = {tokenroom: this.tokenroom, tokenuser: this.tokenuser, time_in: lastitem['timestamp']}
        this.headers = {'Authorization': this.tokenservice}
        this.axios.post(process.env.APImanage + '/message/getdictmessage', this.body, {headers: this.headers}).then((responsed) => {
          if (responsed.data['status'] === 'success') {
            // console.log(responsed.data['data'])
            this.addOldMessage(responsed.data['data'])
            if (responsed.data.data.length === 20) {
              this.statusload = true
            } else if (responsed.data.data.length < 20) {
              this.statusload = false
            }
          } else {
            // this.progressLoadChat = false
          }
        })
        // }
      }
    },
    getMessageFirst () {
      // console.log('getMessageFirst')
      this.listmessage = []
      // console.log(this.listmessage)
      // if (this.listmessage.length === 0) {
      this.body = {tokenroom: this.tokenroom, tokenuser: this.tokenuser, time_in: ''}
      this.headers = {'Authorization': this.tokenservice}
      this.axios.post(process.env.APImanage + '/message/getdictmessage', this.body, {headers: this.headers}).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          // console.log(response.data)
          this.addOldMessage(response.data['data'])
          var container = this.$el.querySelector('#myscroll')
          container.scrollTop = container.scrollHeight
          this.scrollval = container.scrollTop
          if (response.data.data.length === 20) {
            this.statusload = true
          } else if (response.data.data.length < 20) {
            this.statusload = false
          }
        }
      })
      // }
    },
    addOldMessage (data) {
      // console.log(data)
      for (var i = 0; i < data.length; i++) {
        this.date = this.momentdate(data[i].timestamp)
        this.time = this.momenttime(data[i].timestamp)
        if (data[i].tokenuser === this.tokenuser) {
          this.listmessage.unshift({
            sender: 'self',
            msg: data[i].message,
            room: data[i].tokenroom,
            tokenuser: data[i].tokenuser,
            timestamp: data[i].timestamp,
            typemessage: data[i].typeofmessage,
            tokenmessage: data[i].tokenmessage,
            filename: data[i].file_name,
            chatname: data[i].nickname,
            path_pic: data[i].path_pic,
            type: 'guest'
          })
        } else {
          if (data[i].tokenroom === this.tokenroom) {
            this.adminname = data[i].nickname
            this.listmessage.unshift({
              sender: 'other',
              msg: data[i].message,
              room: data[i].tokenroom,
              tokenuser: data[i].tokenuser,
              typemessage: data[i].typeofmessage,
              timestamp: data[i].timestamp,
              tokenmessage: data[i].tokenmessage,
              filename: data[i].file_name,
              chatname: data[i].nickname,
              path_pic: data[i].path_pic,
              type: 'admin'
            })
          }
        }
      }
      setTimeout(this.scrollDown, 1)
    },
    isBlank (str) {
      return (!str || /^\s*$/.test(str))
    },
    isEmpty (str) {
      return (!str || str.length === 0)
    },
    momentdate (data) {
      return Momenttime.momentdatethai(data)
    },
    momenttime (data) {
      return Momenttime.momenttimethai(data)
    },
    extension (path) {
      // console.log(path)
      var extension = path.split('.')[path.split('.').length - 1].toLowerCase()
      var archive = ['zip', 'jar', 'rar', 'tar', 'a', 'ar', 'shar', '7z', 'arj', 'deb', 'pkg', 'gz', 'rpm', 'z']
      var pdf = ['pdf']
      var spreadsheet = ['xls', 'xlt', 'xlsm', 'xlm', 'xlsm']
      var presentation = ['ppt', 'pps', 'pot', 'pptx']
      var word = ['doc', 'docx', 'dot', 'dotx', 'dotm', 'docm', 'docb', 'wbk']
      var execution = ['apk', 'bat', 'bin', 'pl', 'cgi', 'com', 'exe', 'gadget', 'jar', 'py', 'vue', 'wsf', 'css', 'htm', 'html', 'js', 'php', 'xhtml', 'c', 'class', 'cpp', 'vb', 'h', 'sh', 'swift']
      var image = ['ai', 'gif', 'jpeg', 'jpg', 'png', 'bmp', 'ico', 'ps', 'psd', 'svg', 'tif', 'tiff']
      var media = ['mpg', 'mpeg', 'avi', 'wmv', 'mov', 'rm', 'ram', 'swf', 'flv', 'ogg', 'webm', 'mp4']
      var audio = ['mp3', 'wma', 'aac', 'ogg', 'm4a', 'wav', 'cda', 'flac', 'aiff', 'wmv', 'caf']
      if (pdf.includes(extension)) {
        // return 'fas fa-file-pdf'
        return path.split('.')[path.split('.').length - 1]
      } else if (archive.includes(extension)) {
        return 'fas fa-file-archive'
      } else if (spreadsheet.includes(extension)) {
        return 'fas fa-file-excel'
      } else if (presentation.includes(extension)) {
        return 'fas fa-file-powerpoint'
      } else if (word.includes(extension)) {
        return 'fas fa-file-word'
      } else if (execution.includes(extension)) {
        return 'fas fa-file-code'
      } else if (image.includes(extension)) {
        return 'fas fa-file-image'
      } else if (media.includes(extension)) {
        return path.split('.')[path.split('.').length - 1]
      } else if (audio.includes(extension)) {
        return path.split('.')[path.split('.').length - 1]
      } else {
        return 'fas fa-file-alt'
      }
    },
    convert (msg) {
      var linkifyStr = require('linkifyjs/string')
      var str = msg
      var processedContent = linkifyStr(str)
      return processedContent
    }
  }
}
</script>

<style lang="css" scoped>
a:link {
  color: #1976d2;
  text-decoration: none;
}

/* visited link */
a:visited {
  color: #1976d2;
  text-decoration: none;
}

/* mouse over link */
a:hover {
  text-decoration: underline;
  color: #1976d2;
}

/* selected link */
a:active {
  color: #1976d2;
}
.conversation-start {
  position: relative;
  width: 100%;
  margin-bottom: 2vh;
  text-align: center;
}
.conversation-start span {
  /*font-size: 10px;
  display: inline-block;
  color: #999;*/
  border-style: solid;
  font-size: 10px;
  display: inline-block;
  color: #424242;
  border-width: thin;
  border-radius: 10px;
  width: 80px;
}
.conversation-start span:before, .conversation-start span:after {
  position: absolute;
  top: 12px;
  display: inline-block;
  width: 120px;
  height: 1px;
  content: '';
  /*background-color: #e6e6e6;*/
}
.conversation-start span:before {
  left: 0;
}
.conversation-start span:after {
  right: 0;
}
.textfile {
  padding-top: 15px;
  white-space: nowrap;
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.iconfile {
  color: black;
  font-size: 80px !important;
  display: flex;
  justify-content: center;
  margin-top: 1vh;
}
.imageChat {
  word-wrap: break-word;
  border-radius: 10px;
  justify-content: center;
  max-height: 150px;
  max-width: 150px;
}
.headername {
  background-color: #424242;
  height: 50px;
  color: #E0E0E0;
  margin-top: -10px;
  /*margin-bottom: 1vh;*/
  /*position: fixed;*/
  /*width: 100%;*/
  /*margin-top:30px;*/
}

.setHeightChatBox {
  height: calc(100vh - 160px);
  max-height: calc(100vh - 160px);
  overflow-y: scroll;
  padding-top: 5px;
  overflow-x: hidden;
  background: white;
}
.setBgHeader {
  background-color: #01579B;
  height: 30px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.chatBoxFriend {
  word-wrap: break-word;
  /*max-width: 50%;*/
  max-width: 175px;
  border-radius: 25px;
  background: #E0E0E0;
  padding: 12px;
}
.chatBox {
  word-wrap: break-word;
  max-width: 175px;
  /*max-width: 50%; */
  border-radius: 25px;
  padding: 12px;
}

textarea:focus{
  outline: none !important;
  box-sizing: border-box !important;
  resize: none;
}
.textBox{
  height: 50px;
  border-style: solid solid solid solid !important;
  border-width: 1px;
  border-radius: 7px;
  border-color: rgb(101,101,101);
}
.texboxdisabled {
  background-color: #d5d5d5;
  height: 50px;
  border-style: solid solid solid solid !important;
  border-width: 1px;
  border-radius: 7px;
  border-color: rgb(182, 182, 182);
}
.textname {
  padding-left: 5px;
  color: gray;
  font-size: 12px;
  white-space: nowrap;
  width: 5em;
  overflow: hidden;
  text-overflow: ellipsis;
}
.colorFooterMenu {
  color: #424242;
  font-size: 12px;
  padding-left: 5px;
  /*color: gray;
  font-size: 12px;
  white-space: nowrap;
  width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;*/
}
.alligator-turtle {
  object-fit: cover;
  object-position: 50% 0;
}
.user-photoprofilechat{
  background-color: white;
  width: 35px !important;
  height: 35px !important;
  border-radius: 50%;
  overflow: hidden;
  margin: 5px;
}
/* The Modal (background) */
.modalc {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  /*padding-top: 20vh;  Location of the box */
  left: 0;
  top: 0;
  width: 100vw; /* Full width */
  height: 100vh; /* Full height */
  /*overflow: auto;  Enable scroll if needed */
 /* background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.9); /* Black w/ opacity */
  /*background-color: white;*/
}
/* Modal Content (Image) */
.modal-contentc {
  padding-top: 10vh;
  margin: auto;
  display: block;
  width: 80%;
  width: auto;
  height: 70vh;
}
/* Caption of Modal Image (Image Text) - Same Width as the Image */
#caption {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 100vw;
  text-align: center;
  color: #ccc;
  padding: 10px 0;
  height: 150px;
}
#headcaption {
  margin: auto;
  display: block;
  /*width: 80%;*/
  /*max-width: 100vw;*/
  text-align: left;
  color: white;
  /*padding-left: 15vw ;*/
  padding-top: 1vh;
  padding-bottom: 1vh;
  /*background-color: white;*/
  /*background-color: #1b232d;*/
  /*height: 150px;*/
}
/* Add Animation - Zoom in the Modal */
/*.modal-contentc {
    animation-name: zoom;
    animation-duration: 0.6s;
}*/
@keyframes zoom {
    from {transform:scale(0)}
    to {transform:scale(1)}
}
/* The Close Button */
.close {
    position: absolute;
    top: 0vh;
    right: 35px;
    color: white;
    font-size: 40px;
    font-weight: bold;
    transition: 0.3s;
}
.close:hover,
.close:focus {
    color: #bbb;
    text-decoration: none;
    cursor: pointer;
}
/* 100% Image Width on Smaller Screens */
@media only screen and (max-width: 700px){
    .modal-contentc {
        /*width: 100vw;*/
    }
}
.wrapper {
  position: relative;
  /*display: inline-block;*/
}
</style>



// WEBPACK FOOTER //
// src/components/ChatBox.vue